<template>
  <section class="">
    <div class="message-header">Error</div>
    <div class="message-body">
      <div class="mb-10" v-html="props.message"></div>
      <button @click.prevent="handleClose" class="button">Close</button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['props'],
  methods: {
    handleClose() {
      this.$emit('close');
      this.$router.push({ name: 'signin' });
    }
  }
};
</script>
